import IconButton from '@mui/material/IconButton'
import { reExportedColors } from '../../index'
import DeleteIcon from '../../Icons/js/icons/DeleteIcon'

const DeleteIconButton = ({ className, onClick, disabled }) => (
  <IconButton
    className={className}
    disabled={disabled}
    onClick={onClick}
    sx={(theme) => ({
      backgroundColor: reExportedColors.WHITE,
      borderRadius: '50%',
      boxSizing: 'border-box',
      flex: '0 0 24px',
      height: 24,
      maxHeight: 24,
      maxWidth: 24,
      minHeight: 24,
      minWidth: 24,
      overflow: 'hidden',
      padding: 0,
      width: 24,
      '&:hover': {
        backgroundColor: reExportedColors.WHITE,
        '& *': { fill: theme.palette.primary.accent }
      },
      '& > span > div': { height: 24, width: 24 }
    })}
  >
    <DeleteIcon />
  </IconButton>
)

export default DeleteIconButton
